module.exports = __webpack_public_path__ + "img/link.c1c26094.svg";